import { studentSettingsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Student];

const studentSettingsRouteMetadata: IRouteMetadataObj<
  typeof studentSettingsRoutesObj
> = {
  home: {
    title: "settings.title",
    description: "settings.studentDescription",
    lazy: () => import("@pages/studentPages/settings/page"),
    mode: "index",
    type: "inner",
    icon: "Settings2Line",
    breadcrumbs: [],
    permission,
  },
  editProfile: {
    title: "settings.editProfile.title",
    description: "settings.editProfile.description",
    lazy: () => import("@pages/studentPages/editProfile/form/page"),
    mode: "create",
    type: "inner",
    icon: "Settings2Line",
    breadcrumbs: [],
    permission,
  },
  changePassword: {
    title: "settings.changePassword.title",
    description: "settings.changePassword.description",
    lazy: () => import("@pages/studentPages/changePassword/form/page"),
    mode: "create",
    type: "inner",
    icon: "Settings2Line",
    breadcrumbs: [],
    permission,
  },
  changePhoneNumber: {
    title: "settings.changePhoneNumber.title",
    description: "settings.changePhoneNumber.description",
    lazy: () => import("@pages/studentPages/changeMobileNumber/form/page"),
    mode: "create",
    type: "inner",
    icon: "Settings2Line",
    breadcrumbs: [],
    permission,
  },
  privacyPolicy: {
    title: "settings.privacyPolicy.title",
    description: "empty",
    lazy: () => import("@pages/studentPages/privacyPolicy/view/page"),
    mode: "view",
    type: "inner",
    icon: "Settings2Line",
    breadcrumbs: [],
    permission,
  },
  deleteAccount: {
    title: "settings.deleteAccount.title",
    description: "empty",
    lazy: () => import("@pages/studentPages/deleteAccount/form/page"),
    mode: "create",
    type: "inner",
    icon: "Settings2Line",
    breadcrumbs: [],
    permission,
  },
};

export const studentSettingsRoutes = createRoute<
  typeof studentSettingsRoutesObj
>(studentSettingsRoutesObj, studentSettingsRouteMetadata);
